<template>
  <ul class="user-info-create-pattern">
    <li
      :class="[
        'pattern-item',
        activedList.includes(item.options.info.extension.name) ? 'actived' : '',
      ]"
      v-for="(item, index) in patternTypes"
      :key="index"
      @click="addFiled(item)"
    >
      <i :class="['vh-form-iconfont  icon ', `${item.icon}`]" />
      <span class="pattern-label">{{ item.name }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "UserInfoPattern",
  props: {
    qData: {},
  },
  data() {
    return {
      patternTypes: [
        {
          icon: "icon-fill-name",
          name: this.$t("lang.k_899001"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899001"),
              extension: {
                namestr: this.$t("lang.k_899001"),
                name: 1,
              },
            },
          },
        },
        {
          icon: "icon-fill-sex",
          name: this.$t("lang.k_899002"),
          options: {
            type: "radio",
            info: {
              title: this.$t("lang.k_899002"),
              detail: {
                list: [
                  {key: 1, value: this.$t("lang.k_899003")},
                  {key: 2, value: this.$t("lang.k_899004")},
                ],
              },
              extension: {
                namestr: this.$t("lang.k_899002"),
                name: 2,
              },
            },
          },
        },
        {
          icon: "icon-fill-birthday",
          name: this.$t("lang.k_899005"),
          options: {
            type: "date",
            info: {
              title: this.$t("lang.k_899005"),
              extension: {
                namestr: this.$t("lang.k_899005"),
                name: 3,
              },
            },
          },
        },
        {
          icon: "icon-fill-mobile",
          name: this.$t("lang.k_899006"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899006"),
              extension: {
                namestr: this.$t("lang.k_899006"),
                name: 4,
                codeSwitch: 1,
              },
            },
          },
        },
        {
          icon: "icon-fill-email",
          name: this.$t("lang.k_899007"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899007"),
              extension: {
                namestr: this.$t("lang.k_899007"),
                name: 5,
              },
            },
          },
        },
        {
          icon: "icon-fill-education",
          name: this.$t("lang.k_899008"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899008"),
              extension: {
                namestr: this.$t("lang.k_899008"),
                name: 6,
              },
            },
          },
        },
        {
          icon: "icon-fill-industry",
          name: this.$t("lang.k_899009"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899009"),
              extension: {
                namestr: this.$t("lang.k_899009"),
                name: 7,
              },
            },
          },
        },
        {
          icon: "icon-fill-region",
          name: this.$t("lang.k_899010"),
          options: {
            type: "area",
            info: {
              title: this.$t("lang.k_899010"),
              extension: {
                namestr: this.$t("lang.k_899010"),
                name: 8,
              },
            },
          },
        },
        {
          icon: "icon-fill-company",
          name: this.$t("lang.k_899011"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899011"),
              extension: {
                namestr: this.$t("lang.k_899011"),
                name: 9,
              },
            },
          },
        },
        {
          icon: "icon-fill-company",
          name: this.$t("lang.k_899012"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899012"),
              extension: {
                name: 10,
              },
            },
          },
        },
        {
          icon: "",
          name: this.$t("lang.k_899013"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899013"),
              extension: {
                name: 11,
              },
            },
          },
        },
        {
          icon: "",
          name: this.$t("lang.k_899014"),
          options: {
            type: "text",
            info: {
              title: this.$t("lang.k_899014"),
              extension: {
                name: 12,
              },
            },
          },
        },
      ],
    };
  },
  computed: {
    activedList() {
      return this.qData.detail.map((item) => {
        return item.extension.name;
      });
    },
  },
  methods: {
    addFiled(item) {
      this.$emit("addFiled", item.options);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-info-create-pattern {
  width: 120px;
  background: #fff;
  height: 100%;
  overflow-y: auto;
  &::after {
    clear: both;
  }
  .pattern-item {
    box-sizing: border-box;
    padding: 10px 0;
    height: 40px;
    margin-left: 22px;
    cursor: pointer;
    font-size: 14px;
    color: #1a1a1a;
    .icon {
      display: inline-block;
      width: 14px;
      height: 14px;
      font-size: 14px;
    }
    .pattern-label {
      margin-left: 5px;
    }

    &.actived {
      color: #bfbfbf;
      pointer-events: none;
    }
    &:hover {
      color: #fb3a32;
    }
  }
}
</style>
